import React from 'react';
import ctx from 'classnames/bind';
import style from './ArrowIcon.scss';

const cx = ctx.bind(style);

/**
 * @deprecated, use @ott/icon-chevron-right, @ott/icon-small-chevron-right, @ott/icon-arrow-right or @ott/icon-small-arrow-right instead
 */
function ArrowIcon({ w, h, className, childrenClassNames }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 7 10"
      className={cx('arrowIcon', className)}
    >
      <path
        className={cx(childrenClassNames.path)}
        d="M1.33 0L.16 1.17 3.96 5 .17 8.82 1.33 10l5-5"
      />
    </svg>
  );
}

ArrowIcon.defaultProps = {
  w: 7,
  h: 10,
  childrenClassNames: {},
};

ArrowIcon.IS_DEPRECATED = true;

export default ArrowIcon;
